import { Menu, ChevronDown } from '@velocity-exchange/icons';
import { AccordionTriggerProps } from '@radix-ui/react-accordion';
import { MOBILE_OPTIONS_ICONS } from 'src/components/Navigation/config/consts';
import NavItemTags from 'src/components/Navigation/NavItemTags';
import {
	MobileNavigationOption,
	NavigationCategory,
	NavigationState,
} from 'src/components/Navigation/types';
import { cj } from 'src/utils/classNames';

interface Props extends AccordionTriggerProps {
	navCategory: NavigationCategory;
	navOption: MobileNavigationOption;
	handleNavigation: NavigationState['handleNavigation'];
}

export default function MobileNavAccordionTrigger({
	navCategory,
	navOption,
	handleNavigation,
	className,
	onClick,
	...rest
}: Props) {
	const isStaticOption = navOption.type === 'staticOption';

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		if (isStaticOption) {
			handleNavigation(navOption.handler());
		}

		onClick?.(e);
	};

	const Icon = MOBILE_OPTIONS_ICONS[navCategory];

	const { categoryName, newTag, hotTag, tagLabel } = navOption;

	return (
		<button
			className={cj(
				'group flex w-full items-center justify-between py-xl',
				'typo-label-sm text-text-default capitalize',
				className
			)}
			onClick={handleClick}
			data-testid={`mobile-nav-${navCategory}`}
			{...rest}
		>
			<div className="flex items-center gap-x-sm">
				{navCategory === 'more' && <Menu size={16} />}
				{navCategory !== 'more' && Icon && <Icon size={16} />}
				{categoryName}
				<NavItemTags newTag={newTag} hotTag={hotTag} tagLabel={tagLabel} />
			</div>
			{!isStaticOption && (
				<ChevronDown className="transition-transform ease-in-out-quint group-data-[state=open]:rotate-180" />
			)}
		</button>
	);
}
